import React, { Component } from 'react';

import "@material/react-chips/dist/chips.css";
import NavBar from '../../shared/NavBar';
import {Col, Row, Button, Input, Badge, InputGroup, InputGroupAddon, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText, Jumbotron, Card, CardHeader, CardBody} from 'reactstrap';

import {connect} from "react-redux";
import {ChipSet, Chip} from '@material/react-chips';

import './Reports.css';

class Reports extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            newReportVal: '',
            typeValue: "",
            teamValue: "",
            emailValue: "",
            typesList: [],
            teamsList: [],
            emails: [],
            allTeamEmails: [],
            showReportNew: true,
            showTeam: false,
            showEmails: false,
            showAllEmails: false,
            isLoading: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleTeamChange = this.handleTeamChange.bind(this);
        this.createReportType = this.createReportType.bind(this);
        this.getReportTypes = this.getReportTypes.bind(this);
        this.getReportTeams = this.getReportTeams.bind(this);
        this.getReportEmails = this.getReportEmails.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.removeReport = this.removeReport.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        this.getReportTypes();
        this.getReportTeams();
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    handleTypeChange(event) {
        let val = event.target.value;

        this.setState({typeValue: val}, () => {
            if(val == ""){
                this.setState({
                    showReportNew: true,
                    showTeam: false,
                    showAllEmails: false,
                    showEmails: false
                });
            } else {
                this.setState({
                    showReportNew: false, 
                    showTeam: true, 
                    showEmails: false,
                    showAllEmails: true,
                    teamValue: "" 
                }, ()=> {
                    this.getAllEmails();
                }); 
            }
        });
    }

    handleTeamChange(event) {
        let val = event.target.value;

        this.setState({teamValue: val}, () => {
            if(val == ""){
                this.setState({showEmails: false});
            } else {
                this.setState({
                    showEmails: true, 
                    emailValue: "", 
                    emails: [] 
                }, () => {
                    this.getReportEmails();
                });
            } 
            console.log("team", this.state.teamValue, this.state.typeValue)
        });
    }

    createReportType(){
        fetch('https://api.iondeveloper.com/admin/reports/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "addReportType",
                    type_name: this.state.newReportVal,
                    code: this.state.newReportVal.toLowerCase().replaceAll(/ /g, '_')
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            this.setState({newReportVal: ""});
            if (data.success === true){
                this.getReportTypes(()=> {
                    this.setState({
                        typeValue: data.id,
                        showReportNew: false, 
                        showTeam: true, 
                        showEmails: false,
                        showAllEmails: true,
                        teamValue: "" 
                    });
                });
                
            }
        }.bind(this));
    }

    getReportTypes(callback){
        fetch('https://api.iondeveloper.com/admin/reports/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "getReportTypes",
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (data.success === true){
                this.setState({
                    typesList: data.types
                }, ()=> {
                    if(callback) callback();
                });
            }
        }.bind(this));
    }

    getReportTeams(){
        fetch('https://api.iondeveloper.com/admin/reports/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "getReportTeams",
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (data.success === true){
                this.setState({
                    teamsList: data.teams
                });
            }
        }.bind(this));
    }

    getReportEmails(){
        this.setState({isLoading: true }, () => {
            fetch('https://api.iondeveloper.com/admin/reports/', {
                method: 'post',
                body: JSON.stringify(
                    {
                        "method": "getReportEmails",
                        team: this.state.teamValue,
                        type: this.state.typeValue
                    }
                )
            }).then(function(response) {
                return response.json();
            }).then(function(data) {
                this.setState({isLoading: false }, ()=> {
                    if (data.success === true){
                        if(data.emails.length > 0){
                            let emails = data.emails[0].emails;
                            if(emails != ""){
                                let emailArr = emails.split(",");
                                let arr = [];
                                emailArr.forEach(e => {
                                    arr.push({label: e, id: e})
                                });
                                this.setState({emails: arr });
                            }
                        }
                    }
                });
            }.bind(this));
        });
        
    }

    getAllEmails(){
        fetch('https://api.iondeveloper.com/admin/reports/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "getAllEmailsByReport",
                    type: this.state.typeValue
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            this.setState({ allTeamEmails: data.emails });
        }.bind(this));
    }

    saveChanges(){
        let emailStr = "";
        this.state.emails.forEach((e, index) => {
            emailStr += e.id;
            if((index + 1) != this.state.emails.length) emailStr += ",";
        });
        fetch('https://api.iondeveloper.com/admin/reports/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "updateEmails",
                    team: this.state.teamValue,
                    type: this.state.typeValue,
                    emails: emailStr
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (data.success === true){
                this.getAllEmails();
                alert("Emails updated successfully!");
            }
        }.bind(this));
    }

    removeReport(){
        fetch('https://api.iondeveloper.com/admin/reports/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "removeReport",
                    type: this.state.typeValue
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (data.success === true){
                this.getReportTypes();
                this.setState({
                    showReportNew: true,
                    showTeam: false,
                    showAllEmails: false
                });

                alert("Report removed successfully!");
            }
        }.bind(this));
    }

    handleKeyDown = (e) => {
        const label = e.target.value;
        if (!!label && e.key === 'Enter') {
          const id = label.replace(/\s/g,'');
          const emails = [...this.state.emails];
          if (emails.some((v) => v.id === id)) {
            console.error('There is already a chip which has same key.');
          } else {
            emails.push({label, id});
            this.setState({emails});
            e.target.value = '';
          }
        }
    };
    
    render() {
        const { showReportNew, showTeam, showEmails, isLoading, showAllEmails } = this.state;
        const isEmailEmpty = (this.state.emails.length == 0);
        const isAllEmailEmpty = (this.state.allTeamEmails == 0);

        let typeOptions = [];
        typeOptions.push(
            <option key={""} value={""}>Create New Report</option>
        );
        for (var i = 0; i < this.state.typesList.length; i++){
            typeOptions.push(
                <option key={i} value={this.state.typesList[i].id}>{this.state.typesList[i].type}</option>
            );
        }

        let teamsOptions = [];
        teamsOptions.push(
            <option key={""} value={""}>Select a team</option>
        );
        for (var i = 0; i < this.state.teamsList.length; i++){
            teamsOptions.push(
                <option key={i} value={this.state.teamsList[i].team_id}>{this.state.teamsList[i].team_name}</option>
            );
        }

        return (
            <div>
                <NavBar />
                <div className="container">
                    <div className="email-container">
                        <h3>Assign Emails </h3>
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col xs="12" sm="12" md="6" lg="6" center >
                                        <h5>REPORT: </h5>
                                        <select class="team-select" value={this.state.typeValue} onChange={this.handleTypeChange}>
                                            {typeOptions}
                                        </select>
                                        {showReportNew && (
                                            <InputGroup>
                                                <Input type="text" placeholder="Enter New Report" name="newReportVal" value={this.state.newReportVal} onChange={this.handleInputChange} />
                                                <InputGroupAddon addonType="append">
                                                    <Button color="success" onClick={this.createReportType}>Add Report</Button>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        )}
                                    </Col>
                                    <Col xs="12" sm="12" md="6" lg="6" center >
                                        {showTeam && (
                                            <div>
                                                <h5>TEAM: </h5>
                                                <select class="team-select" value={this.state.teamValue} onChange={this.handleTeamChange}>
                                                    {teamsOptions}
                                                </select>
                                            </div>
                                        )}
                                    </Col>
                                </Row>

                                {showEmails && (
                                    <div>
                                        <Jumbotron className="container-emails">
                                            {isLoading && (<label>Fetching email list ...</label>)}
                                            {!isLoading && isEmailEmpty && (<label>No emails assigned yet.</label>)}
                                            <ChipSet input updateChips={(emails) => this.setState({emails})} >
                                                { this.state.emails.map((chip) =>
                                                    <Chip id={chip.id} key={chip.id} label={chip.label} trailingIcon={<label className="btn-close-trail" color="danger"> x </label>} />
                                                )}
                                            </ChipSet>
                                        </Jumbotron>
                                        <InputGroup>
                                            <Input type="email" placeholder="Type email and press enter to add" onKeyDown={this.handleKeyDown}></Input>
                                        </InputGroup>

                                        <Button className="btn-email-save" color="primary" block onClick={this.saveChanges}>Save Changes</Button>
                                    </div> 
                                )}
                            </CardHeader>
                            <CardBody>
                                {showAllEmails && (
                                    <div>
                                        <div className="container all-group-emails">
                                            {isAllEmailEmpty && (<h5>No email assigned to this report yet.</h5>)}
                                            {/* {!isAllEmailEmpty && (<h5>ALL EMAILS ASSIGNED</h5>)} */}
                                            <ListGroup flush> 
                                            { this.state.allTeamEmails.map((emails) =>
                                                (
                                                    <ListGroupItem>
                                                        <ListGroupItemHeading>{emails.team_name}</ListGroupItemHeading>
                                                        <ListGroupItemText>
                                                        { 
                                                            emails.emails.map((email) =>
                                                                <Badge className="report-badge" color="info">{email}</Badge>
                                                        )}
                                                        </ListGroupItemText>
                                                    </ListGroupItem>
                                                )
                                            )}
                                            </ListGroup>
                                            <Button className="btn-email-save" color="danger" block onClick={this.removeReport}>Remove Report</Button>
                                        </div>
                                        
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    <div>
                    </div>
                        
                        
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        state: state
    };
}

export default connect(mapStateToProps)(Reports);


// WEBPACK FOOTER //
// ./src/components/pages/Reports/Reports.js